import { render, staticRenderFns } from "./EditPhotoFaceDialog.vue?vue&type=template&id=546e4500&"
import script from "./EditPhotoFaceDialog.vue?vue&type=script&lang=js&"
export * from "./EditPhotoFaceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports